import { Rule, createPlugin, utils } from 'stylelint';

const functionArgumentsSearch = (
    require('stylelint/lib/utils/functionArgumentsSearch.mjs') as {
        default: (
            source: string,
            functionName: string,
            callback: (args: string, index: number) => void
        ) => void;
    }
).default;

const isAbsoluteUrl = (url: string) => /^\//.test(url) && !/^\/\//.test(url);

const ruleName = '@servicetitan/function-url-no-absolute';
const messages = utils.ruleMessages(ruleName, {
    rejected: 'Unexpected absolute url',
});

const plugin: Rule = actual => {
    return (root, result) => {
        const validOptions = utils.validateOptions(result, ruleName, { actual });

        if (!validOptions) {
            return;
        }

        root.walkDecls(decl => {
            functionArgumentsSearch(decl.toString().toLowerCase(), 'url', (args, index) => {
                const url = args.replace(/(^[ '"]+)|([ '"]+$)/g, '');

                if (!isAbsoluteUrl(url)) {
                    return;
                }

                utils.report({
                    message: messages.rejected,
                    node: decl,
                    index,
                    endIndex: index + args.length,
                    result,
                    ruleName,
                });
            });
        });
    };
};

plugin.ruleName = ruleName;
plugin.messages = messages;

export = Object.assign(createPlugin(ruleName, plugin), { ruleName, messages });
